import { useEffect, useState } from "react";
/**
 * Subscribes to a CSS media query and returns whether it currently matches.
 * Drop-in replacement for Mantine's `useMediaQuery` — same signature.
 */
export function useMediaQuery(query) {
    const [matches, setMatches] = useState(() => {
        if (typeof window === "undefined" || !window.matchMedia)
            return false;
        return window.matchMedia(query).matches;
    });
    useEffect(() => {
        if (typeof window === "undefined" || !window.matchMedia)
            return;
        const mql = window.matchMedia(query);
        const onChange = () => setMatches(mql.matches);
        onChange();
        mql.addEventListener("change", onChange);
        return () => mql.removeEventListener("change", onChange);
    }, [query]);
    return matches;
}
